export const css = {
	root: 'rgIFhGlw',
	scoreblock: 'DUcfP7QM',
	legend: '_3xhfaVLT',
	scoreIcon: '_1XmdIusX',
	assessIcon: '_2YnqKiaK',
	topicGroup: 'h8J3gw9b',
	topicsetList: '_2rTc9qq2',
	' _key': 'prepost-viz/prepost-viz'
};

export default css;
